import { useEffect, useState, useRef } from 'react';
import { Notification } from '@workboard/wobo-ui';
import { useTranslation } from 'react-i18next';

import { loadFederatedModule } from './loadFederatedModule';

const ErrorPage = () => {
  const { t } = useTranslation();
  return (
    <div id="article-container" style={{ paddingTop: '70px' }}>
      <section id="blog" className="white">
        <div className="container">
          <div className="row">
            <div className="col-sm-3" />
            <div className="col-sm-6 col-xs-12">
              <img src={`${window.wbConfig.baseUrl}//images/404.png`} alt="Server Error" style={{ maxWidth: '100%' }} />
            </div>
            <div className="col-sm-3" />
          </div>
          <div className="row">
            <div className="col-sm-3" />
            <div style={{ minHeight: '1px', position: 'relative', clear: 'both', float: 'inherit' }}>
              <h2 style={{ textAlign: 'center' }}>{t('Take a moment...')}</h2>
              <p style={{ paddingBottom: '20px', paddingTop: '14px', fontWeight: '400', textAlign: 'center' }}>
                {t('The server has encountered an error.  Please try again.')}
              </p>
              <br />
            </div>
            <div className="col-sm-3" />
          </div>
        </div>
      </section>
    </div>
  );
};

const RemoteAppWrapper = ({ data }) => {
  const { t } = useTranslation();
  const wrapperRef = useRef(null);

  const { module, scope, externalData } = data;
  const [remoteModule, setRemoteModule] = useState(null);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    if (remoteModule) {
      const { mount } = remoteModule;
      mount(wrapperRef.current, externalData);
    }
  }, [remoteModule, externalData]);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const fetchedModule = await loadFederatedModule(`${scope}/${module.replace(/^\.\//, '')}`);
        if (!cancelled) setRemoteModule(fetchedModule);
      } catch (error) {
        if (!cancelled) setShowError(true);
      }
    };
    if (!remoteModule) load();
    // eslint-disable-next-line consistent-return
    return () => {
      cancelled = true;
    };
  }, [remoteModule, module, scope]);

  return (
    <>
      <div ref={wrapperRef} />
      {showError && <ErrorPage />}
      <Notification
        open={showError}
        message={t('Service temporarily unavailable')}
        severity="error"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        persist
        onClose={() => setShowError(false)}
      />
    </>
  );
};

export default RemoteAppWrapper;
